import React from "react";
import "./conclave css files/footerconclave.css";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaPlay } from "react-icons/fa";
const logo_media = require("../../assets/conclave assets/media_logo.png");

function ConclaveFooter(props) {
  return (
    <section className="conclave_footer_main_container">
      <div className="conclave_under_footer_main_container">
        <div className="conclave_footer_all_content_container">
          <div className="footer_first_content_container">
            <p className="follow_us_text_footer_title">FOLLOW US</p>
            <div className="social_link_logo_container">
              <a href="www.fb.com" className="social_link_square_container">
                <FaFacebookF className="per_social_icon" />
              </a>
              <a href="www.fb.com" className="social_link_square_container">
                <FaTwitter className="per_social_icon" />
              </a>
              <a href="www.fb.com" className="social_link_square_container">
                <FaLinkedinIn className="per_social_icon" />
              </a>
              <a href="www.fb.com" className="social_link_square_container">
                <FaPlay className="per_social_icon" />
              </a>
            </div>
          </div>

          <div className="footer_sec_content_container">
            <div className="title_logo_container">
              <p className="follow_us_text_footer_title">MEDIA PARTNERS</p>
              <a href="logo" className="logo_media_container">
                <img src={logo_media} loading="lazy" alt="logo_media" />
              </a>
            </div>
          </div>
          <div className="footer_third_content_container">
            <a href="privacy_policy" className="privacy_text">
              Privacy
            </a>{" "}
            |{" "}
            <a href="terms" className="privacy_text">
              Terms & Conditions
            </a>{" "}
            |
            <p className="privacy_text">
              {" "}
              &#169; 2022 DWEC All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ConclaveFooter;
